"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Contentlive = function Contentlive(_ref) {
  var title = _ref.title,
      description = _ref.description,
      width = _ref.width,
      height = _ref.height,
      rest = _objectWithoutProperties(_ref, ["title", "description", "width", "height"]);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    "aria-hidden": !title,
    "aria-labelledby": "ContentliveTitle ContentliveDescription",
    height: height,
    preserveAspectRatio: "none",
    role: "img",
    viewBox: "0 0 24 24",
    width: width
  }, rest), /*#__PURE__*/_react["default"].createElement("title", {
    id: "ContentliveTitle"
  }, title), /*#__PURE__*/_react["default"].createElement("desc", {
    id: "ContentliveDescription"
  }, description), /*#__PURE__*/_react["default"].createElement("g", {
    id: "LessonType/contentLive",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    transform: "scale(1 1)",
    d: "M12,7.4 C13.4359403,7.4 14.6,8.56405965 14.6,10 C14.6,11.1448714 13.8600271,12.1169128 12.8322628,12.4639427 L14.41,16.41 L14.4242641,16.4242641 L14.418,16.43 L16.557086,21.7771656 C16.787869,22.354123 16.1074259,22.8375253 15.6435518,22.4837087 L15.5757359,22.4242641 L12,18.849 L8.42426407,22.4242641 C7.98486638,22.8636618 7.27250991,22.4286573 7.41498976,21.8629146 L7.44291399,21.7771656 L9.581,16.43 L9.57573593,16.4242641 L9.589,16.41 L11.1677372,12.4639427 C10.1399729,12.1169128 9.4,11.1448714 9.4,10 C9.4,8.56405965 10.5640597,7.4 12,7.4 Z M10.504,17.353 L9.643,19.507 L11.151,18 L10.504,17.353 Z M13.495,17.353 L12.849,18 L14.356,19.507 L13.495,17.353 Z M11.999,13.616 L10.99,16.141 L12,17.151 L13.009,16.141 L11.999,13.616 Z M12,1.4 C16.7496488,1.4 20.6,5.25035115 20.6,10 C20.6,12.6324665 19.4090256,15.0707357 17.400494,16.6932315 C17.1427208,16.9014612 16.7649508,16.8612983 16.5567211,16.603525 C16.3484914,16.3457518 16.3886543,15.9679818 16.6464275,15.7597521 C18.3758658,14.3627085 19.4,12.2660094 19.4,10 C19.4,5.91309285 16.0869071,2.6 12,2.6 C7.91309285,2.6 4.6,5.91309285 4.6,10 C4.6,12.2675128 5.62550432,14.3654582 7.35690067,15.7624391 C7.61479357,15.9705205 7.65517374,16.3482674 7.44709228,16.6061603 C7.23901083,16.8640532 6.86126398,16.9044333 6.60337108,16.6963519 C4.59256579,15.0739293 3.4,12.6342147 3.4,10 C3.4,5.25035115 7.25035115,1.4 12,1.4 Z M12,4.4 C15.0927946,4.4 17.6,6.9072054 17.6,10 C17.6,11.4009188 17.082833,12.7228974 16.16488,13.7435632 C15.9432908,13.9899468 15.5639239,14.0100465 15.3175403,13.7884573 C15.0711567,13.5668681 15.051057,13.1875012 15.2726462,12.9411176 C15.9943312,12.138681 16.4,11.1017132 16.4,10 C16.4,7.5699471 14.4300529,5.6 12,5.6 C9.5699471,5.6 7.6,7.5699471 7.6,10 C7.6,11.1053681 8.00838282,12.1455229 8.73439279,12.9489256 C8.9565661,13.1947826 8.93736668,13.5741961 8.69150969,13.7963694 C8.4456527,14.0185427 8.06623917,13.9993433 7.84406586,13.7534863 C6.92062307,12.7316045 6.4,11.4055727 6.4,10 C6.4,6.9072054 8.9072054,4.4 12,4.4 Z M12,8.6 C11.2268014,8.6 10.6,9.22680135 10.6,10 C10.6,10.7731986 11.2268014,11.4 12,11.4 C12.7731986,11.4 13.4,10.7731986 13.4,10 C13.4,9.22680135 12.7731986,8.6 12,8.6 Z",
    id: "LiveLesson-Icon",
    fill: "#12131A",
    fillRule: "nonzero"
  })));
};

Contentlive.defaultProps = {
  description: '',
  height: 24,
  title: null,
  width: 24
};
Contentlive.propTypes = {
  description: _propTypes["default"].string,
  height: _propTypes["default"].number,
  title: _propTypes["default"].string,
  width: _propTypes["default"].number
};
var _default = Contentlive;
exports["default"] = _default;